<template>
      <div>
          <div class="px-4 text-center text-uppercase">
          <h4 class="mt-4 mb-1 mx-auto">Confirmation Code</h4>
          <h3 class="text-red peak-sans text-bold mx-auto">{{ rebate.confirmation_code }}</h3>
          </div>
          <p class="text-center my-5 peak-sans" v-if="rebate.status>3000">Your rebate of ${{ rebate.amount }} was accepted on {{ rebate.updated_at }} and is currently being processed. Please add <i>do-not-reply@pplusshorebate.com</i> to your approved senders list to ensure your rebate is received. </p>
              <p class="text-center my-5 peak-sans" v-else-if="isRejected">Your rebate of {{ rebate.amount }} was not accepted.  {{rebate.status_text}}</p>
              <p class="text-center my-5 peak-sans" v-else>We are processing your request.  Upon approval, a rebate will be sent to the email you&nbsp;provided. <span class="d-inline-block my-4">You can check the status of your rebate anytime using the "Check Existing Rebate" option on this site. You should receive your rebate within 4-6 weeks. </span></p>
      </div>

</template>

<script>
    export default {
        name:"RebateConfirmation",
        mounted(){
         //this.$store.dispatch('getStatuses');
        },
        data() {
            return {
                rebate: {
                    id:'',
                    customer: '',
                    email: '',
                    confirmation_code: '',
                    status: '',
                    status_text: '',
                    amount: '',
                    created: '',
                    updated: '',
                },
                newRebate:'',
                confirmed:false,
            }
          },
        methods: {
            setData(rebateInfo) {
                this.rebate.id = rebateInfo.id;
                this.rebate.confirmation_code = rebateInfo.confirmation_code;
                this.rebate.amount = rebateInfo.amount;
                this.rebate.email= rebateInfo.sho_customer.email;
                this.rebate.customer = rebateInfo.sho_customer.first_name + " " + rebateInfo.sho_customer.last_name;
                this.rebate.status = rebateInfo.status;
                this.rebate.status_text = rebateInfo.rebate_status.status_text;
                this.rebate.created = this.moment(rebateInfo.created_at).format('M/D/YY');
            },
        },
        computed:{
            isRejected(){
                if(this.rebate.status !== ''){
                    return (3000 > this.rebate.status  && this.rebate.status > 1999 ? true : false)
                }
            },
        }
     }
</script>
